import React from "react";
import { Badge } from "@/src/components/ui/badge.tsx";
import { handleAnalyticsClick } from "@/src/utils/analytics";
import { API_ENDPOINTS } from "@/src/config/api.js";

const Interviews = () => {
    let [responseData, setResponseData] = React.useState("");
    const fetchData = React.useCallback(() => {
        fetch(API_ENDPOINTS.interviews.json())
            .then(response => response.json())
            .then((response) => {
                let sliced = Object.fromEntries(Object.entries(response).slice(0, 5))
                setResponseData(sliced);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);
    React.useEffect(() => {
        fetchData();
    }, []);
    if (!responseData) return null;

    const handleInterviewClick = (event, interviewData) => {
        const eventParams = {
            eventCategory: 'Interviews',
            eventAction: 'Click',
            eventLabel: `${interviewData.interviewed}`,
            interviewId: interviewData.interview_id,
            interviewDate: interviewData.interview_date
        };

        handleAnalyticsClick('home_interview', eventParams, event);
    };

    const interviews = Object.entries(responseData).map(([key, value]) => (
        <div key={value.interview_id} className="flex items-start space-x-3 mb-6 group cursor-pointer">

            <div className="relative flex-shrink-0">
                <a href={`/interviews/${value.interview_base_route}`} onClick={(e) => handleInterviewClick(e, value)}>
                    <img
                        src={`https://www.dreamchimney.com/interviews/static/img/${value.interview_id}/${value.interview_id}-share-wide.jpg`}
                        alt={value.interviewed}
                        className="w-[200px] h-[100px] object-cover rounded-md group-hover:opacity-75 transition-opacity"
                    />
                </a>
            </div>
            <div className="flex-1">
                <Badge className="bg-interviews-blue mb-2">INTERVIEW</Badge>
                <h3 className="text-sm font-bold line-clamp-2">{value.interviewed}</h3>
                <p className="text-xs text-gray-400 mt-1">{value?.interview_date}</p>
            </div>
        </div>
    ));

    return responseData && <div className="space-y-3">{interviews}</div>;
};

export default Interviews;
